import { render } from "./UploadImage.vue?vue&type=template&id=ad01f674&ts=true"
import script from "./UploadImage.vue?vue&type=script&lang=ts"
export * from "./UploadImage.vue?vue&type=script&lang=ts"

import "./UploadImage.vue?vue&type=style&index=0&id=ad01f674&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_Phoi/ZaloOA_Phoi_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__